import React from 'react';
import LinkedOptions from './linkedOptions';
import TopQuestion from '../../utils/question/topQuestion';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
	const {
		rightSectionProps: { choices, instruction },
		leftSectionProps: { videoId, question, questionId, imagesrc, queDesc },
	} = state.rootReducer.testPageDetails;

	return {
		choices,
		videoId,
		question,
		imagesrc,
		queDesc,
		instruction,
		questionId,
	};
};
const LinkedQuestion = () => {
	return (
		<span>
			<section className="">
				<TopQuestion />
			</section>
			<section className="quiz-page-wide-left">
				<LinkedOptions />
			</section>
		</span>
	);
};

export default connect(mapStateToProps)(LinkedQuestion);
